/* eslint-disable react/no-unescaped-entities */

import 'react-circular-progressbar/dist/styles.css';
import './EmailVerificationInstruction.scss';

import { yupResolver } from '@hookform/resolvers/yup';
import { Modal } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import DEFAULTINBOX from '../../../../assets/images/EmailInstruction/email_gmail_inbox.png';
import DEFAULTSPAM from '../../../../assets/images/EmailInstruction/email_gmail_spam.png';
import HOTMAILTINBOX from '../../../../assets/images/EmailInstruction/email_outlook_inbox.png';
import HOTMAILSPAM from '../../../../assets/images/EmailInstruction/email_outlook_spam.png';
import YAHOOINBOX from '../../../../assets/images/EmailInstruction/email_yahoo_inbox.png';
import YAHOOSPAM from '../../../../assets/images/EmailInstruction/email_yahoo_spam.png';
import HEADERIMAGE from '../../../../assets/images/HeadersImages/Contact-Header.png';
import ModalClose from '../../../../assets/images/modalClose.svg';
import Button from '../../../../components/Button/Button';
import { Form } from '../../../../components/Form/Form';
import Input from '../../../../components/Form/Input/Input';
import ImageComponent from '../../../../components/ImageComponent/ImageComponent';
import ModalLogo from '../../../../components/modals/ModalLogo/ModalLogo';
import SuccessMessage from '../../../../components/SuccessMessage/SuccessMessage';
import { getToken } from '../../../../services/token-service/token.service';
import { resendVerificationEmail } from '../../../../services/user-service/user.service';
import getEmailFromParams from '../../../../V2/helpers/getEmailFromParams';
import { useFreshChat } from '../../../../V2/hooks/useFreshChat';
import { EmailVerificationStatusEnum } from '../../../../V2/model/enum/EmailVerificationStatusEnum.enum';
import { useGetUserEmailVerificationStatus } from '../../../../V2/services/user/useGetUserEmailVerificationStatus';

const schema = yup.object().shape({
  email: yup.string().required('Email is required!').email('Invalid Email Address'),
  old_email: yup.string().required('Email is required!').email('Invalid Email Address')
});

const EmailVerificationInstruction = () => {
  const resendEmail = useRef(null);
  const [inboxImage, getInboxImage] = useState();
  const [spamImage, getSpamImage] = useState();
  const [showSuccesMessage, setShowSuccesMessage] = useState(false);
  const queryParameters = new URLSearchParams(window.location.search);
  const token = queryParameters.get('userToken');

  // Helper function to process email with + sign handling
  const processEmailWithHelper = (email) => {
    if (!email) return email;
    const tempParams = new URLSearchParams();
    tempParams.set('email', email);
    return getEmailFromParams(tempParams);
  };

  // Get emails from query parameters and process them
  const currentEmailFromQuery = queryParameters.get('current-email');
  const emailFromQuery = queryParameters.get('email');
  const processedCurrentEmail = processEmailWithHelper(currentEmailFromQuery);
  const processedEmail = processEmailWithHelper(emailFromQuery);
  const finalEmailFromQuery = processedCurrentEmail || processedEmail;

  const encodedEmail = token && atob(token).includes('email') ? JSON.parse(atob(token)).email : '';

  // Process localStorage email and encodedEmail too
  const localStorageEmail = localStorage.getItem('current-email');
  const processedLocalStorageEmail = processEmailWithHelper(localStorageEmail);
  const processedEncodedEmail = processEmailWithHelper(encodedEmail);

  const userEmail = finalEmailFromQuery ?? processedLocalStorageEmail ?? processedEncodedEmail;
  const {
    data: userEmailVerificationStatus,
    isLoading,
    isError,
    error
  } = useGetUserEmailVerificationStatus(userEmail);
  const [verificationModalVisible, setVerificationModalVisible] = useState(false);
  const shouldShowHelpButton =
    userEmailVerificationStatus?.status === EmailVerificationStatusEnum.Failed;
  const userUsername = null; //getUserData().username;
  const address = userEmail?.split('@').pop();
  const [additionalErr, setAdditionalErr] = useState();
  const [mailProvider, setMailProvider] = useState();
  const { showWidget } = useFreshChat({ mode: 'manual' });

  useEffect(() => {
    const pattern = /@(.+)$/;

    const match = userEmail?.match(pattern);

    if (match) {
      const domain = match[1];
      setMailProvider(domain);
    } else {
    }
  }, [userEmail]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(schema)
  });

  useEffect(() => {
    if (userEmail) {
      setValue('old_email', userEmail);
    }
  }, [userEmail, setValue]);

  useEffect(() => {
    localStorage.removeItem('current-email');
    localStorage.setItem('current-email', userEmail);
  });

  useEffect(() => {
    switch (address) {
      case 'hotmail.com':
      case 'outlook.com':
        getInboxImage(HOTMAILTINBOX);
        return getSpamImage(HOTMAILSPAM);
      case 'yahoo.com':
        getInboxImage(YAHOOINBOX);
        return getSpamImage(YAHOOSPAM);
      default:
        getInboxImage(DEFAULTINBOX);
        return getSpamImage(DEFAULTSPAM);
    }
  }, [address]);

  const resendEmailFailed = (err) => {
    setShowSuccesMessage(false);
    setAdditionalErr(err?.response?.data?.message ?? err?.data?.message);
  };

  const resendEmailSuccess = () => {
    setShowSuccesMessage(true);
    setAdditionalErr('');
  };

  const onSubmit = (data) => {
    setAdditionalErr('');
    setShowSuccesMessage(false);
    resendVerificationEmail(data, getToken()).then(resendEmailSuccess).catch(resendEmailFailed);
  };
  const getUserMobileOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check for iOS
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    // Check for Android
    if (/android/i.test(userAgent)) {
      return 'Android';
    }
    return 'Unknown';
  };
  const redirectToEmail = () => {
    if (queryParameters.get('apple_email') === '1') {
      return 'message://';
    }

    switch (mailProvider) {
      case 'gmail.com':
        return `https://mail.google.com/mail/u/0/#search/from%3ALocalFlirt+in%3Aall+OR+in%3Aspam+subject%3Averification`;
      case 'yahoo.com':
        return `https://www.${address}`;
      case 'hotmail.com':
        return `https://www.${address}`;
      case 'outlook.com':
        return `https://www.${address}`;
      default:
        return undefined;
    }
  };
  const renderButton = () => {
    return redirectToEmail() ? (
      <Button
        className="CheckYourEmailButton"
        type="button"
        onClick={() => window.open(redirectToEmail(), '_blank')}
        text="Check Your Email"
      />
    ) : (
      <p className="EmailVerification-Description">Remember to check your spam folder</p>
    );
  };

  useEffect(() => {
    if (!isLoading) {
      setVerificationModalVisible(isError || shouldShowHelpButton);
    }
  }, [isLoading, isError, shouldShowHelpButton]);

  const handleLiveChatClick = () => {
    showWidget();
    setVerificationModalVisible(false);
  };

  return (
    <div className="EmailVerificationInstruction">
      <div className="EmailVerification-HeaderContainer">
        <ImageComponent url={HEADERIMAGE} className="EmailVerification-HeaderImage" />
        <div className="Header-Text">
          <div className="EmailVerification-Header">Email Verification Instructions</div>
          <p className="EmailVerification-Description">
            You are just one step away from having full acces to LocalFlirt. An email has been sent
            to
            <span> {userEmail} </span>with a verification link. Please click the link in order to
            complete the registration.
          </p>
          <div className="CheckYourEmailButton-Container">{renderButton()}</div>
        </div>
      </div>
      <div className="EmailVerification-Container">
        {shouldShowHelpButton && (
          <div className="HelpMeWithVerificationButtonWrapper">
            <Button
              type="primary"
              onClick={() => setVerificationModalVisible(true)}
              className="HelpMeWithVerificationButton"
            >
              Help me with verification!
            </Button>
          </div>
        )}
        <div className="HowToVerify">
          <div className="HowToVerify-Container Container">
            <div className="ImageContainer">
              <ImageComponent url={inboxImage} className="EmailVerification-Image" />
            </div>
            <div className="InfoContainer">
              <div className="InfoTitle">How to Verify Your Account</div>
              <div className="InfoDescription">
                Open your email client and there you will find an email from us containing a link.
              </div>
              <div className="InfoDescription">
                Click on the link within the email and your account will then get verified within a
                few seconds!
              </div>
            </div>
          </div>
        </div>
        <div className="HaventReceivedEmail">
          <div className="HaventReceivedEmail-Container Container">
            <div className="InfoContainer">
              <div className="InfoTitle">Haven't received the verification email?</div>
              <div className="InfoDescription">
                Make sure to double check if it has ended up in the junk folder. You can find it in
                this folder by checking here.
              </div>
            </div>
            <div className="ImageContainer">
              <ImageComponent url={spamImage} className="EmailVerification-Image" />
            </div>
          </div>
        </div>
        <div className="StillHaventReceivedEmail-Container">
          <div className="StillHaventReceivedEmail Container">
            <div className="StillHaventReceivedEmailTitle">Still no email?</div>
            {/* {!showLoader ? (
              <div className="StillHaventReceivedEmailSMS">
                <p className="StillHaventReceivedEmailSMS-Text">
                  Fill out your phone number to receive the verification link by SMS
                </p>
                <div className="SendEmailAgain">
                  <Form className="SendEmailAgainForm" onSubmit={handleSubmitSMS(onSubmitSMS)}>
                    <Input
                      type="text"
                      register={registerSMS}
                      className="SendEmailAgainInput"
                      name="phone"
                      placeholder="Phone Number"
                      errorMessage={errorsSMS?.phone?.message}
                    />
                    <Button
                      className="SendEmailAgainButton"
                      type="submit"
                      text="Send"
                      onClick={handleSubmitSMS(onSubmitSMS)}
                      disabled={isLoadingSMSVerification}
                    />
                  </Form>
                </div>
              </div>
            ) : (
              <div className="SendEmailAgainLoaderContainer">
                <div className="SendEmailAgainLoader">
                </div>
                <p className="SendEmailAgainLoaderText">
                  We can only send you the link every <span>60</span> sec
                </p>
                <p className="SendEmailAgainLoaderText">
                  Thank you for your request. We've <span>sent a text message</span> to the provided
                  number with a <span>link</span> to log into your account.
                </p>
              </div>
            )} */}
            <div className="StillHaventReceivedEmailDescription">
              Drop us an email at{' '}
              <a
                className="Support-Text"
                href="mailto:support@localflirt.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                support@localflirt.com
              </a>{' '}
              and we will make sure to help you!
            </div>
            <div className="StillHaventReceivedEmailDescription">
              Have you entered the wrong email address? No worries, just enter the correct email
              address below and we will send you a new verification email.
            </div>
            <div className="SendEmailAgain">
              <Form className="SendEmailAgainForm" onSubmit={handleSubmit(onSubmit)}>
                <Input
                  register={register}
                  className="SendEmailAgainInput"
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  errorMessage={errors?.email?.message}
                  additionalError={additionalErr}
                />
                <input type="submit" ref={resendEmail} hidden />
                <Button
                  className="SendEmailAgainButton"
                  type="submit"
                  onClick={() => {
                    resendEmail.current.click();
                  }}
                  text="Send"
                />
              </Form>
            </div>
          </div>
        </div>
      </div>
      <SuccessMessage
        showMessage={showSuccesMessage}
        setShowMessage={setShowSuccesMessage}
        message="A verification email has been sent to you"
      />
      <Modal
        wrapClassName="VerificationModal"
        open={verificationModalVisible}
        footer={null}
        onCancel={() => setVerificationModalVisible(false)}
        maskClosable
        closeIcon={<img src={ModalClose} alt={'close'} />}
      >
        <ModalLogo />
        <h2 className="VerficationModal-Title">We were unable to deliver your email!</h2>
        <p className="VerficationModal-Description">
          {shouldShowHelpButton
            ? `It appears we are unable to deliver your confirmation email to ${userEmail}. But don't worry! You can still verify your account and start flirting instantly using live support below!`
            : isError && error?.response?.status === 404
            ? 'We could not find your email. Please check the address or try signing up again.'
            : isError && error?.response?.status === 403
            ? 'You do not have permission to access this verification. Please contact support.'
            : 'Something went wrong. Please try again later.'}
        </p>
        <h2 className="VerficationModal-Subtitle">Verify by Live Support</h2>
        <p className="VerficationModal-Description">
          Click the button below for instant live chat support
        </p>
        <Button
          className="HelpVerifyButton"
          onClick={handleLiveChatClick}
          text="Help Me with Verification now!"
        />
        <div className="VerficationModal-Description" style={{ marginTop: '1rem' }}>
          Or drop us an email at{' '}
          <a
            className="Support-Text"
            href="mailto:support@localflirt.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            support@localflirt.com
          </a>
        </div>
      </Modal>
    </div>
  );
};

export default EmailVerificationInstruction;
